import BaseColumnHead from './BaseColumnHead';

export default BaseColumnHead;
